import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from "@/views/LoginPage";
import DashboardPage from "@/views/DashboardPage";
import OrganizationsPage from "@/views/OrganizationsPage";
import DevicesLockers from "@/views/devices/DevicesLockers";
import DevicesLogs from "@/views/devices/DevicesLogs";
import ControlUnits from "@/views/devices/DevicesControlUnits";
import LocationsPage from "@/views/locations/LocationsPage.vue";
import DevicesDetail from "@/views/devices/DevicesDetail.vue";
import DevicesFirmwares from "@/views/devices/DevicesFirmwares.vue";
import OrdersPage from "@/views/OrdersPage.vue";
import DevicesModels from "@/views/devices/DevicesModels.vue";
import PaymentsPage from "@/views/PaymentsPage.vue";
import MaintenancePage from "@/views/MaintenancePage.vue";
import OrderDetailPage from "@/views/OrderDetailPage.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/dashboard',
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: DashboardPage,
        meta: {
            title: 'Dashboard - Lockerbot admin panel',
            pageTitle: 'Dashboard',
            crumbs: ['Overview'],
            requiresAuth: true,
        },
    },
    {
        // the old add-locker wizard; adding is now a modal on /lockers
        path: '/lockers/new',
        redirect: { name: 'lockers' },
    },
    {
        path: '/lockers',
        name: 'lockers',
        component: DevicesLockers,
        meta: {
            title: 'Lockers - Lockerbot admin panel',
            pageTitle: 'Lockers',
            crumbs: ['Operations', 'Lockers'],
            requiresAuth: true,
        },
    },
    {
        path: '/lockers/:slug',
        name: 'locker',
        component: DevicesDetail,
        meta: {
            title: 'Lockers - Lockerbot admin panel',
            pageTitle: 'Lockers',
            crumbs: ['Operations', 'Lockers'],
            requiresAuth: true,
        },
    },
    {
        path: '/devices-logs',
        name: 'devices-logs',
        component: DevicesLogs,
        meta: {
            title: 'Devices logs - Lockerbot admin panel',
            pageTitle: 'System logs',
            crumbs: ['Operations', 'System logs'],
            requiresAuth: true,
        },
    },
    {
        path: '/control-units',
        name: 'control-units',
        component: ControlUnits,
        meta: {
            title: 'Control units - Lockerbot admin panel',
            pageTitle: 'Control Units',
            crumbs: ['Hardware', 'Control Units'],
            requiresAuth: true,
        },
    },
    {
        path: '/organizations',
        name: 'organizations',
        component: OrganizationsPage,
        meta: {
            title: 'Organizations - Lockerbot admin panel',
            pageTitle: 'Organizations',
            crumbs: ['Directory', 'Organizations'],
            requiresAuth: true,
        },
    },
    {
        path: '/locations',
        name: 'locations',
        component: LocationsPage,
        meta: {
            title: 'Locations - Lockerbot admin panel',
            pageTitle: 'Locations',
            crumbs: ['Directory', 'Locations'],
            requiresAuth: true,
        },
    },
    {
        path: '/payments',
        name: 'payments',
        component: PaymentsPage,
        meta: {
            title: 'Payments - Lockerbot admin panel',
            pageTitle: 'Payments',
            crumbs: ['Operations', 'Payments'],
            requiresAuth: true,
        },
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: MaintenancePage,
        meta: {
            title: 'Maintenance - Lockerbot admin panel',
            pageTitle: 'Maintenance',
            crumbs: ['Operations', 'Maintenance'],
            requiresAuth: true,
        },
    },
    {
        path: '/device-models',
        name: 'device-models',
        component: DevicesModels,
        meta: {
            title: 'Device Models - Lockerbot admin panel',
            pageTitle: 'Device Models',
            crumbs: ['Directory', 'Device Models'],
            requiresAuth: true,
        },
    },
    {
        path: '/firmwares',
        name: 'firmwares',
        component: DevicesFirmwares,
        meta: {
            title: 'Firmwares - Lockerbot admin panel',
            pageTitle: 'Firmwares',
            crumbs: ['Hardware', 'Firmwares'],
            requiresAuth: true,
        },
    },
    {
        path: '/orders',
        name: 'orders',
        component: OrdersPage,
        meta: {
            title: 'Rental Orders - Lockerbot admin panel',
            pageTitle: 'Rental Orders',
            crumbs: ['Operations', 'Rental Orders'],
            requiresAuth: true,
        },
    },
    {
        path: '/orders/:id',
        name: 'order-detail',
        component: OrderDetailPage,
        meta: {
            title: 'Order Details - Lockerbot admin panel',
            pageTitle: 'Order',
            crumbs: ['Operations', 'Rental Orders'],
            requiresAuth: true,
        },
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: {
            title: 'Login - Lockerbot admin panel',
        },
    },
    // otherwise redirect to home
    { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (localStorage.getItem('token')) {
            next();
            return;
        }
        next('/login');
    } else {
        next();
    }
});

export default router
